import { useState } from "react";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import CreateMoneyReceipt from "./CreateMoneyReceipt";
import { Button } from "@mui/material";
import type { SingleExhibitorInvoiceInfo } from "../type/exhibitorType";

const InvoiceWithMoneyReceipt = ({
	invoiceDetails,
}: {
	invoiceDetails?: SingleExhibitorInvoiceInfo;
}) => {
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	return (
		<>
			<Button onClick={() => handleOpen()}>Create MoneyReceipt</Button>
			<ModalsWrapper
				showModal={open}
				setShowModal={setOpen}
				modalData={{ title: "Create Money Receipt" }}
			>
				<CreateMoneyReceipt
					invoiceDetails={invoiceDetails}
					handleClose={handleClose}
				/>
			</ModalsWrapper>
		</>
	);
};

export default InvoiceWithMoneyReceipt;
